import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PersonService } from 'app/services/models/person.service';
import { ToastrService } from 'ngx-toastr';
import * as XLSX from 'xlsx';

import * as ExcelJS from 'exceljs';
import * as FileSaver from 'file-saver'

@Component({
  selector: 'app-get-all-persons-point-dialog',
  templateUrl: './get-all-persons-point-dialog.component.html',
  styleUrls: ['./get-all-persons-point-dialog.component.scss']
})
export class GetAllPersonsPointDialogComponent implements OnInit {
  @Input() data;

  selectedYear!: number;
  selectedMonth!: number;

  datas: any[] = [];
  isLoading = false;
  public searchValue = null;

  years: number[] = [];
  months = [
    { value: 1, name: 'Ocak' },
    { value: 2, name: 'Şubat' },
    { value: 3, name: 'Mart' },
    { value: 4, name: 'Nisan' },
    { value: 5, name: 'Mayıs' },
    { value: 6, name: 'Haziran' },
    { value: 7, name: 'Temmuz' },
    { value: 8, name: 'Ağustos' },
    { value: 9, name: 'Eylül' },
    { value: 10, name: 'Ekim' },
    { value: 11, name: 'Kasım' },
    { value: 12, name: 'Aralık' },
  ];

  legendData = [
    { kod: 'X', tanim: 'Çalıştı' },
    { kod: 'HT', tanim: 'Hafta Tatili' },
    { kod: 'D', tanim: 'Diğer İzin' },
    { kod: 'R', tanim: 'Resmi Tatil' },
    { kod: 'Yi', tanim: 'Yıllık İzin' },
    { kod: 'HTC', tanim: 'Hafta Tatili Çalışması' },
    { kod: 'RTC', tanim: 'Resmi Tatil Çalışması' },
  ];

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private toastrService: ToastrService,
    private personService: PersonService,
  ) { }

  ngOnInit(): void {
    const currentYear = new Date().getFullYear();
    this.years = [currentYear - 2, currentYear - 1, currentYear];
    this.selectedYear = currentYear;
    this.selectedMonth = new Date().getMonth() + 1;
  }

  async getAllActivePersonPoints(year, month, search) {
    const data = await this.personService.getAllActivePersonPoints(year, month, search)
    console.log(data);
  }

  async submit() {
    this.isLoading = true;
    try {
      if (this.data == true) {
        this.datas = await this.personService.getMonthlyPersonWorkSummary(this.selectedYear, this.selectedMonth, this.searchValue);
      } else {
        this.datas = await this.personService.getAllActivePersonPoints(this.selectedYear, this.selectedMonth, this.searchValue);
        if (this.datas != null) {
          this.datas = this.datas.map(p => ({
            ...p,
            other: Number(String(p.other).replace(',', '.'))
          }));
        }
      }
      console.log(this.datas);
      if (!this.datas || this.datas.length === 0) {
        this.toastrService.info("Seçilen tarihe ait veri bulunamadı.");
      }
    } catch (err) {
      this.toastrService.error("Veriler alınırken bir hata oluştu.");
    } finally {
      this.isLoading = false;
    }
  }

  filterUpdate(event) {
    const val = event.target.value.toLocaleLowerCase('tr-TR');
    this.searchValue = val ?? null;
  }
  /*
    exportAsExcel(): void {
      let exportData;
      if (this.data == true) {
        exportData = this.datas.map((d: any) => ({
          'Sicil No': d.registrationNumber,
          'Ad Soyad': d.fullName,
          'Departman': d.department,
          'Yıllık İzin (Gün)': d.annualLeave,
          'Ücretsiz İzin (Gün)': d.unpaidLeave,
          'Rapor (Gün)': d.reportLeave,
          'Evlilik İzni (Gün)': d.marriageLeave,
          'Doğum İzni (Gün)': d.maternityLeave,
          'Cenaze İzni (Gün)': d.funeralLeave,
          'İdari İzin (Gün)': d.administrativeLeave,
          'Hafta İçi Mesai (saat)': d.weekdayOvertime,
          'Hafta Sonu Mesai (saat)': d.weekendOvertime,
          'Uzaktan Mesai (saat)': d.remoteWork,
          'Telafi Çalışması (saat)': d.compensationWork,
          'Destek Çalışması (saat)': d.supportWork,
          'Resmi Tatil Mesaisi (saat)': d.officialHoliday,
        }));
      } else {
        exportData = this.datas.map((d: any) => {
          const days = Object.fromEntries(
            Object.entries(d.days).map(([key, value]) => [`Gün ${key}`, value])
          );
  
          return {
            'Ad Soyad': d.fullName,
            'Departman': d.depertmant,
            'Yıllık İzin': d.annualLeave,
            'Rapor': d.report,
            'Diğer İzinler': d.other,
            'Çalışma Günü': d.onlyXDays,
            ...days
          };
        });
      }
  
      const worksheet = XLSX.utils.json_to_sheet(exportData);
  
      const range = XLSX.utils.decode_range(worksheet['!ref']!);
      for (let col = range.s.c; col <= range.e.c; ++col) {
        const cellAddress = XLSX.utils.encode_cell({ r: 0, c: col });
        const cell = worksheet[cellAddress];
        if (cell) {
          cell.s = {
            fill: {
              fgColor: { rgb: 'DCE6F1' } // Açık mavi
            },
            font: {
              bold: true
            },
            alignment: {
              horizontal: 'center'
            }
          };
        }
      }
    
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Aylık Rapor');
      XLSX.writeFile(workbook, `${this.data == true ? 'Aylik_Rapor' : 'Puantaj_Rapor'}_${this.selectedMonth}_${this.selectedYear}.xlsx`);
    }
  */

  exportAsExcel(): void {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Aylık Rapor');

    let exportData;
    if (this.data === true) {
      exportData = this.datas.map((d: any) => ({
        'Sicil No': d.registrationNumber,
        'Ad Soyad': d.fullName,
        'Departman': d.department,
        'Yıllık İzin (Gün)': this.parseSafeNumber(d.annualLeave),
        'Ücretsiz İzin (Gün)': this.parseSafeNumber(d.unpaidLeave),
        'Rapor (Gün)': this.parseSafeNumber(d.reportLeave),
        'Evlilik İzni (Gün)': this.parseSafeNumber(d.marriageLeave),
        'Doğum İzni (Gün)': this.parseSafeNumber(d.maternityLeave),
        'Cenaze İzni (Gün)': this.parseSafeNumber(d.funeralLeave),
        'İdari İzin (Gün)': this.parseSafeNumber(d.administrativeLeave),
        'Hafta İçi Mesai (saat)': this.parseSafeNumber(d.weekdayOvertime),
        'Hafta Sonu Mesai (saat)': this.parseSafeNumber(d.weekendOvertime),
        'Uzaktan Mesai (saat)': this.parseSafeNumber(d.remoteWork),
        'Telafi Çalışması (saat)': this.parseSafeNumber(d.compensationWork),
        'Destek Çalışması (saat)': this.parseSafeNumber(d.supportWork),
        'Resmi Tatil Mesaisi (saat)': this.parseSafeNumber(d.officialHoliday),
      }));
    } else {
      exportData = this.datas.map((d: any) => {

        const sabitAlanlar = {
          'Sicil No': d.registrationNumber,
          'Ad Soyad': d.fullName,
          'Departman': d.depertmant,
          'Yıllık İzin': this.parseSafeNumber(d.annualLeave),
          'Rapor': this.parseSafeNumber(d.report),
          'Diğer İzinler': this.parseSafeNumber(d.other),
          'Çalışma Günü': this.parseSafeNumber(d.onlyXDays),
        };

        // Günler: key'leri string olarak al, sayısal sıralama uygula
        const gunler = Object.fromEntries(
          Object.entries(d.days)
            .sort(([a], [b]) => Number(a) - Number(b)) // Sayısal sıralama
            .map(([key, value]) => [` ${key}`, value]) // Başına boşluk ekle
        );

        return { ...sabitAlanlar, ...gunler };

      });
    }

    // Sütunları tanımla
    const headers = Object.keys(exportData[0]);
    worksheet.columns = headers.map(header => ({
      header,
      key: header,
      width: 20
    }));

    // Verileri ekle
    exportData.forEach(data => {
      worksheet.addRow(data);
    });


    worksheet.getRow(1).height = 30; // Satır yüksekliği (varsayılan genelde 15-20 civarıdır)

    worksheet.columns.forEach((column) => {
      let maxLength = 1; // Minimum genişlik
      column.eachCell({ includeEmpty: true }, (cell) => {
        const cellValue = cell.value ? cell.value.toString() : '';
        maxLength = Math.max(maxLength, cellValue.length);
      });
      column.width = maxLength + 1; // Biraz boşluk ekle
    });

    // Başlık hücrelerini stillendir
    worksheet.getRow(1).eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '256CA6' }, // Açık mavi
      };
      cell.font = { bold: true };
      cell.alignment = {
        horizontal: 'center', // Yatay ortalama
        vertical: 'middle'    // Dikey ortalama
      };
    });

    if (this.data !== true) {



      if (this.data == false) {
        const legendSheet = worksheet; // Aynı sayfaya ekliyoruz

        // Sağ tarafa, örneğin 2 sütun boşluk bırakarak ekleyelim
        const startCol = worksheet.columnCount + 2;
        let startRow = 2;

        // Başlık ekle
        legendSheet.getCell(startRow, startCol).value = 'Kod';
        legendSheet.getCell(startRow, startCol + 1).value = 'Tanım';
        legendSheet.getRow(startRow).font = { bold: true };

        // Stil (hücre arka planı ve hizalama)
        legendSheet.getRow(startRow).eachCell((cell) => {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '256CA6' },
          };
          cell.alignment = { horizontal: 'center', vertical: 'middle' };
        });

        // Verileri ekle
        this.legendData.forEach((item) => {
          startRow++;
          legendSheet.getCell(startRow, startCol).value = item.kod;
          legendSheet.getCell(startRow, startCol + 1).value = item.tanim;
        });

        // Genişlikleri ayarla
        legendSheet.getColumn(startCol).width = 10;
        legendSheet.getColumn(startCol + 1).width = 25;
      }

    }
    // Dosyayı dışa aktar
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], { type: 'application/octet-stream' });
      FileSaver.saveAs(blob, `${this.data === true ? 'Aylik_Rapor' : 'Puantaj_Rapor'}_${this.selectedMonth}_${this.selectedYear}.xlsx`);
    });
  }

  parseSafeNumber(value: any): number {
    if (typeof value === 'string') {
      value = value.replace(',', '.'); // Virgül varsa noktaya çevir
    }
    const number = Number(value);
    return isNaN(number) ? 0 : number; // Geçersizse 0 döner
  }

  close() {
    this.activeModal.close();
  }
}